export interface FaqItem {
  id: string;
  question: string;
  answer: string;
}

export const faqList: FaqItem[] = [
  {
    id: 'faq-1',
    question: '什么是磁力链接？如何使用磁力链接下载资源？',
    answer: '磁力链接（Magnet Link）是一种基于P2P技术的资源定位方式，它通过文件内容的哈希值来唯一标识资源，不需要依赖中心化的Tracker服务器。使用磁力链接下载资源，您需要安装支持磁力链接的下载工具，如比特彗星（BitComet）、qBittorrent、迅雷等。复制磁力链接后，在下载工具中新建任务粘贴即可开始下载。磁力链接的优势在于不依赖特定的服务器，即使某个网站关闭，只要有人在做种，资源仍然可以下载。',
  },
  {
    id: 'faq-2',
    question: '磁力网站大全收录的网站都是安全可靠的吗？',
    answer: '我们收录的磁力网站均经过团队人工审核和测试，重点关注网站的稳定性、资源质量和用户体验。我们会定期检查已收录网站的运行状态，及时更新或移除失效链接。但需要提醒的是，磁力网站本身不存储任何资源文件，仅提供磁力链接索引服务，用户下载的资源内容由P2P网络中的其他用户提供。建议用户在使用任何磁力网站时，注意个人信息安全，不要下载来源不明的可执行文件。',
  },
  {
    id: 'faq-3',
    question: '为什么有些磁力链接下载速度很慢或无法下载？',
    answer: '磁力链接的下载速度取决于多个因素：一是做种人数，做种的人越多，下载速度越快；二是资源热度，新发布的资源通常做种人数较多，老资源可能做种人数减少；三是您的网络环境，P2P下载受网络运营商策略影响。如果遇到下载速度慢的情况，可以尝试以下方法：切换不同的磁力网站搜索同一资源找到更多种子、在下载工具中添加Tracker服务器列表、选择做种数较多的磁力链接。',
  },
  {
    id: 'faq-4',
    question: '如何判断一个磁力网站是否值得使用？',
    answer: '判断一个磁力网站的好坏，可以从以下几个方面考量：第一，资源丰富度，好的磁力网站应该有大量的资源索引；第二，更新速度，优秀的网站会及时收录最新资源；第三，搜索精准度，能否快速找到想要的资源；第四，网站稳定性，是否经常无法访问；第五，用户界面体验，是否方便浏览和搜索。本站收录的磁力网站都从这些维度进行了综合评估，并提供了评分和详细评价供您参考。',
  },
  {
    id: 'faq-5',
    question: '磁力网站大全多久更新一次网站收录？',
    answer: '我们的团队每周会对已收录的磁力网站进行一次全面巡检，检查网站的运行状态、更新情况等信息。同时，我们会持续关注新兴的优质磁力网站，经过评估后将符合条件的网站及时收录到导航中。如果您发现了好的磁力网站想要推荐给我们，也可以通过关于我们页面的联系表单提交推荐，我们的团队会尽快进行审核评估。',
  },
  {
    id: 'faq-6',
    question: '使用磁力链接下载资源是否合法？',
    answer: '磁力链接本身是一种合法的P2P技术协议，广泛用于合法文件分发。但通过磁力链接下载受版权保护的内容可能涉及法律风险，具体情况取决于您所在国家/地区的法律法规。我们建议用户仅下载和分享自己拥有版权或获得授权的资源，尊重知识产权。本站作为导航平台，仅提供磁力网站的索引和介绍，不存储、不提供任何资源文件。',
  },
  {
    id: 'faq-7',
    question: '有哪些好用的磁力下载工具推荐？',
    answer: '常用的磁力下载工具有：1）qBittorrent（免费开源，无广告，跨平台支持）；2）BitComet比特彗星（老牌工具，功能丰富）；3）Transmission（轻量级，适合NAS和服务器）；4）Deluge（插件扩展性强）；5）迅雷（国内用户多，下载加速效果好但含有广告）。对于普通用户，推荐使用qBittorrent，它免费、纯净、功能完善，是最受欢迎的磁力下载工具之一。',
  },
];